const axios  = require('./axios').default;
const { LOGIN_API_URL } = require('../helper/application-conf').default;

const handleLoginFromAuth = (siteName: string, userName: string, password: string) => {
  const bodyFormData = new URLSearchParams();
  bodyFormData.append('customer', siteName);
  bodyFormData.append('username', userName);
  bodyFormData.append('password', password);
  const response = axios.post(LOGIN_API_URL,
    bodyFormData,
    {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }
  );
  return response;
};

export default handleLoginFromAuth;
